//  base url
const prodConfig = {
  baseURL: "https://api.youtheducation.co.in",
  // baseURL: "http://192.168.29.41:5001",
};

// In development, use relative URLs so requests go through the dev-server
// proxy (src/setupProxy.js) — the API has no CORS headers for localhost.
const devConfig = {
  baseURL: "",
};

export const config =
  process.env.NODE_ENV === "development" ? devConfig : prodConfig;